// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__XMdsc","verifying":"Button_verifying__IZep6","loader":"Button_loader__73uck","rotation":"Button_rotation__ryBVV"};